import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { alertActions } from '../redux/AlertController';

export const useDriverInactivityAlert = () => {
    const [settings, setSettings] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const dispatch = useDispatch();
    const user = useSelector(state => state.userController.user);

    const fetchDriverInactivityAlertSettings = async () => {
        try {
            setIsLoading(true);
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/driver-inactivity-alert`, {
                headers: {
                    'Authorization': `Bearer ${user?.token}`
                }
            });
            const json = await response.json();

            if (!response.ok) {
                throw new Error(json.error);
            }

            setSettings(json);
            return json;
        } catch (error) {
            dispatch(alertActions.showAlert({ msg: error.message, type: 'error' }));
            return null;
        } finally {
            setIsLoading(false);
        }
    };

    const updateDriverInactivityAlertSettings = async (data) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/driver-inactivity-alert`, {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${user?.token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            const json = await response.json();

            if (!response.ok) {
                throw new Error(json.error);
            }

            setSettings(json);
            dispatch(alertActions.showAlert({ msg: 'تم حفظ إعدادات التنبيه بنجاح', type: 'success' }));
            return json;
        } catch (error) {
            dispatch(alertActions.showAlert({ msg: error.message, type: 'error' }));
            throw error;
        }
    };

    useEffect(() => {
        if (user?.token) {
            fetchDriverInactivityAlertSettings();
        }
    }, [user]);

    return {
        settings,
        isLoading,
        fetchDriverInactivityAlertSettings,
        updateDriverInactivityAlertSettings
    };
};
